import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const HERO_IMAGE = `${process.env.PUBLIC_URL}/hero-background.png`;

export default function Hero() {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative w-full h-screen min-h-[640px] overflow-hidden flex items-center justify-center"
    >
      {/* Background image */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={HERO_IMAGE}
          alt=""
          className="hero-bg-media"
          data-testid="hero-background-image"
        />
      </div>

      {/* Dark overlay for readable typography (~52% opacity) */}
      <div
        className="absolute inset-0"
        style={{ background: "rgba(31,51,41,0.52)" }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-body italic tracking-[0.35em] text-xs sm:text-sm uppercase mb-6"
          style={{
            color: "#d4e8e0",
            textShadow: "0 1px 12px rgba(31,51,41,0.45)",
          }}
          data-testid="hero-eyebrow"
        >
          — Welcome to a Safe Space —
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="font-display font-bold leading-[1.02] text-white"
          style={{
            fontSize: "clamp(2.5rem, 7vw, 5rem)",
            letterSpacing: "0.01em",
            textShadow:
              "0 2px 28px rgba(31,51,41,0.55), 0 1px 6px rgba(31,51,41,0.35)",
          }}
          data-testid="hero-headline"
        >
          Listening Beyond Words,
          <br />
          Seeing Beyond Symptoms
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.55 }}
          className="font-body italic mt-6 text-base sm:text-lg md:text-xl max-w-2xl mx-auto"
          style={{
            color: "#eef6f1",
            textShadow: "0 1px 14px rgba(31,51,41,0.5)",
          }}
          data-testid="hero-subheadline"
        >
          Professional Psychological Care for Children &amp; Adults by Dr. Fiza
          Hasny
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.8 }}
          className="mt-10"
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: "spring", stiffness: 300 }}
            onClick={() => go("contact")}
            data-testid="hero-cta-button"
            className="font-display font-semibold tracking-widest uppercase text-sm sm:text-base px-9 py-4 rounded-full text-white shadow-lg"
            style={{
              background: "var(--color-accent)",
              boxShadow: "0 18px 40px -12px rgba(107,158,140,0.65)",
            }}
          >
            Book a Consultation
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}
